import { render, staticRenderFns } from "./PriceLabeling.vue?vue&type=template&id=7c2e04f2&"
import script from "./PriceLabeling.vue?vue&type=script&lang=js&"
export * from "./PriceLabeling.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports